@if (loading === false) {
<div class="header-container">
    <h2 class="heading">Generate Teltonika Batch Report</h2>
    <app-generic-table-header (dateRangeChange)="updateDates($event)"
        [config]="headerConfig"></app-generic-table-header>
    @if (isHIP) {
    <div class="switch">
        <mat-label class="labelBeforeSlide">Tags</mat-label>
        <mat-slide-toggle [(ngModel)]="viewDevices" (toggleChange)="reset()">Devices</mat-slide-toggle>
    </div>
    }
</div>
<div class="tables">
    @if (viewDevices){
    <tools-table #selectedDevicesTable ApiPath="/teltonika/advanced/" [DisplayCount]="10" ExtraQuery="?teltonika=true"
        [Selectable]="true" [Headers]="deviceTableHeaders" [Search]="true" [Slim]="true" [SortColumn]="'ID'"
        [PrimaryColumn]="'name'" [HTTPData]="{TeltonikaReachable:null}" [HTTPPost]="true" [Multiple]="true"
        (Selected)="addSelectedDevice($event)" [SelectAll]="true" (AllSelected)="allDevicesSelectedEvent($event)"
        (SearchChange)="searchDevices($event)" [ClearSelectAllOnSearch]="true"></tools-table>
    }@else {
    <tools-table ApiPath="/teltonika/tags/" [Headers]="tagTableHeaders" #table [Search]="true" [HTTPPost]="false"
        [Slim]="true" [DisplayCount]="10" [DynamicCount]="true" [Selectable]="true" [Multiple]="false"
        (Selected)="addSelectedTag($event)"></tools-table>
    }
</div>
<div>
    <button mat-raised-button
        [disabled]="(selectedDevices.length <= 0 && selectedTags.length <= 0 && !allDevicesSelected) || dates == null"
        (click)="generateReport()">
        Generate Report
    </button>
</div>
} @else {
<mat-spinner style="margin: auto"></mat-spinner>
}